import { render, staticRenderFns } from "./SocialSignin.vue?vue&type=template&id=66b4e09c&scoped=true&"
import script from "./SocialSignin.vue?vue&type=script&lang=js&"
export * from "./SocialSignin.vue?vue&type=script&lang=js&"
import style0 from "./SocialSignin.vue?vue&type=style&index=0&id=66b4e09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4e09c",
  null
  
)

export default component.exports